import React, { createContext, useContext, useEffect, useRef, useCallback } from "react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const WSContext = createContext(null);
export const useWS = () => useContext(WSContext);

export function WSProvider({ children }) {
  const wsRef = useRef(null);
  const listeners = useRef(new Set());
  const retryRef = useRef(null);

  const connect = useCallback(() => {
    const token = localStorage.getItem("xealth-token");
    if (!token) return;
    const wsUrl = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws?token=${token}`;
    let ws;
    try {
      ws = new WebSocket(wsUrl);
    } catch {
      return;
    }
    wsRef.current = ws;
    ws.onmessage = (e) => {
      try {
        const data = JSON.parse(e.data);
        listeners.current.forEach((fn) => fn(data));
      } catch {}
    };
    ws.onclose = () => {
      retryRef.current = setTimeout(connect, 3000);
    };
    ws.onerror = () => { try { ws.close(); } catch {} };
  }, []);

  useEffect(() => {
    connect();
    return () => {
      clearTimeout(retryRef.current);
      try { wsRef.current?.close(); } catch {}
    };
  }, [connect]);

  const send = useCallback((data) => {
    if (wsRef.current?.readyState === WebSocket.OPEN) {
      wsRef.current.send(JSON.stringify(data));
    }
  }, []);

  const subscribe = useCallback((fn) => {
    listeners.current.add(fn);
    return () => listeners.current.delete(fn);
  }, []);

  return <WSContext.Provider value={{ send, subscribe }}>{children}</WSContext.Provider>;
}
